/* eslint-disable */
import React, { useCallback, useRef } from "react";
import { Button, classnames, Icon } from "@culturehq/components";

import { useDocumentEvent, useDoor } from "app/hooks";

import { containedBy, Trans } from "app/utils";
import styles from "./styles.module.scss";
import EmbedStoriesSlider from "./EmbedStoriesSlider";
import EmbedLandingPage from "./EmbedLandingPage";
import EmbedStoryTrendsSlider from "./EmbedStoryTrendsSlider";
import EmbedSingleStory from "./EmbedSingleStory";
import { useProfile } from "app/context";
import EmbedSingleStoryJobMappings from "./EmbedSingleStoryJobMappings";

const EmbedOptions = ({ botToken, onClose, orgName, selectedStories }) => {
  const { profile } = useProfile();

  return (
    <ul className="dropdown-menu">
      <li>
        <EmbedStoriesSlider
          botToken={botToken}
          orgName={orgName}
          onClose={onClose}
          selectedStories={selectedStories}
        />
      </li>
      <li>
        <EmbedStoryTrendsSlider
          botToken={botToken}
          onClose={onClose}
          orgName={orgName}
        />
      </li>
      <li>
        <EmbedLandingPage
          onClose={onClose}
        />
      </li>
      {profile.culturehqAdmin && (
        <li>
          <EmbedSingleStory
            orgName={orgName}
            onClose={onClose}
            stories={selectedStories}
          />
        </li>
      )}
      {profile.organization.externalMappedIds && (
        <li>
          <EmbedSingleStoryJobMappings
            orgName={orgName}
            onClose={onClose}
            stories={selectedStories}
          />
        </li>
      )}
    </ul>
  );
};

const EmbedStoriesButton = ({
  className, children, onClose, open, onToggle, closeOnOutsideClick, nextToMenu
}) => {
  const containerRef = useRef();

  useDocumentEvent("click", useCallback(
    event => {
      if (!containedBy(event.target, "chq-mdl") && containerRef.current
        && !containerRef.current.contains(event.target) && closeOnOutsideClick) {
        onClose();
      }
    },
    [closeOnOutsideClick, onClose]
  ));

  const classList = classnames(
    "QuickOptions",
    "QuickOptions--Actions",
    styles.quick,
    styles[className],
    nextToMenu && styles["menu-next"],
    open && styles["quick-open"]
  );

  return (
    <div ref={containerRef} className={classList}>
      <Button aria-label="Embed" className="Gray-Button" onClick={onToggle}>
        <Icon icon="code" /><Trans>Embed</Trans>
      </Button>
      {open && (
        <div className={classnames("QuickOptions__menu-wrapper", styles["quick--wrap"])}>
          <div className={classnames("QuickOptions__menu box-shadow", styles["quick--menu"])}>
            {children}
          </div>
        </div>
      )}
    </div>
  );
};

const EmbedStories = ({
  className, closeOnOutsideClick = false, nextToMenu = false, orgName, selectedStories = [], botToken
}) => {
  const { open, onClose, onToggle } = useDoor(false);

  return (
    <EmbedStoriesButton
      open={open}
      onClose={onClose}
      onToggle={onToggle}
      className={className}
      closeOnOutsideClick={closeOnOutsideClick}
      nextToMenu={nextToMenu}
    >
      <EmbedOptions
        botToken={botToken}
        onClose={onClose}
        orgName={orgName}
        selectedStories={selectedStories}
      />
    </EmbedStoriesButton>
  );
};

export default EmbedStories;
